module.exports = __webpack_public_path__ + "img/1111.5f04895b.png";